import { ClickAwayListener } from '@material-ui/core';
import CloseImage from '@assets/svg/close.svg';
import { Image } from '@mantine/core';
import { IUserMember } from '@services/queries/studios/getUserMembers/getUserMembers';
import {
  Icon,
  Item,
  Label,
} from '@components/UpdatesPageMenus/Components/ReAssignDialog/ReAssignDialog.styles';
import AvatarDefaultImg from '@assets/svg/avatar-placeholder.svg';
import {
  Close,
  Search,
  SearchContainer,
  SearchImg,
  StyledOption,
  Container,
  ShowOptions,
  Div,
  ImagePlaceholder,
} from './SearchBarExpansiveUser.styles';

interface SearchBarProps {
  showOptions: IUserMember[];
  searchText: string;
  placeholder: string;
  searchOnKeyDown: (event: any) => void;
  closeIconOnClick: () => void;
  handleClickSearch: () => void;
  onClickFilter: (input: IUserMember) => void;
  searchOnChange: any;
  setShowOptions: (input: IUserMember[]) => void;
}
const SearchBarExpansiveUser = ({
  searchText,
  placeholder,
  handleClickSearch,
  setShowOptions,
  searchOnChange,
  searchOnKeyDown,
  closeIconOnClick,
  showOptions,
  onClickFilter,
}: SearchBarProps) => {
  const handleClickAway = () => {
    setShowOptions([]);
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Div>
        <SearchContainer>
          <SearchImg />
          <Search
            onClick={handleClickSearch}
            haveResults={showOptions ? showOptions.length > 0 : false}
            value={searchText}
            placeholder={placeholder}
            onChange={e => searchOnChange(e.target.value)}
            onKeyDown={searchOnKeyDown}
            autoComplete="off"
          />

          {searchText.length > 0 && (
            <Close src={CloseImage} alt="close" onClick={closeIconOnClick} />
          )}
        </SearchContainer>
        <ShowOptions haveResults={showOptions.length > 0}>
          <Container haveResults={showOptions.length > 0}>
            {showOptions.map(item => (
              <StyledOption
                onClick={() => {
                  onClickFilter(item);
                }}
              >
                <Item>
                  <Icon>
                    {item.picture ? (
                      <Image
                        src={item?.picture || AvatarDefaultImg}
                        alt=""
                        radius={12}
                        width="24px"
                        height="24px"
                        styles={() => ({
                          image: {
                            borderRadius: '12',
                          },
                          imageWrapper: {
                            borderRadius: '12',
                          },
                        })}
                        placeholder={
                          <ImagePlaceholder
                            className="defaultImage"
                            src={AvatarDefaultImg}
                            alt=""
                          />
                        }
                      />
                    ) : (
                      <ImagePlaceholder
                        className="defaultImage"
                        src={AvatarDefaultImg}
                        alt=""
                      />
                    )}
                  </Icon>
                  <Label>{item?.name}</Label>
                </Item>
              </StyledOption>
            ))}
          </Container>
        </ShowOptions>
      </Div>
    </ClickAwayListener>
  );
};

export { SearchBarExpansiveUser };
